export default {
  en: {
    jumbotron: {
      index: {
        welcome: 'Learn talking to ATC',
        intro: 'Train with real procedures, official test questions and improve your skills in the simulator.',
        imageAlt: 'Cessna Caravan animated to simulate takeoff and landing',
      }
    }
  },
  de: {
    jumbotron: {
      index: {
        welcome: 'Lerne mit ATC zu sprechen',
        intro: 'Trainiere mit echten Verfahren, offiziellen Testfragen und verbessere deine Fähigkeiten im Simulator.',
        imageAlt: 'Cessna Caravan animiert, um Start und Landung zu simulieren',
      }
    }
  },
  es: {
    jumbotron: {
      index: {
        welcome: 'Aprende a hablar con ATC',
        intro: 'Entrena con procedimientos reales, preguntas de examen oficiales y mejora tus habilidades en el simulador.',
        imageAlt: 'Cessna Caravan animada para simular despegue y aterrizaje',
      }
    }
  },
  uk: {
    jumbotron: {
      index: {
        welcome: 'Навчіться розмовляти з ATC',
        intro: 'Тренуйтеся з реальними процедурами, офіційними тестовими запитаннями та покращуйте свої навички в симуляторі.',
        imageAlt: 'Cessna Caravan анімована для моделювання зльоту та посадки',
      }
    }
  }
}
